import { Authorization, User } from "../types";
import Service from "../common/Services/Service";

class AuthService extends Service {
  constructor() {
    super({
      path: "/auth",
      queryKey: "auth",
    });
  }

  static fetchCurrentUser() {
    return new AuthService().fetchCurrentUser();
  }

  static refreshCurrentUser() {
    return new AuthService().refreshCurrentUser();
  }

  fetchCurrentUser(): Promise<User> {
    return this.get();
  }

  refreshCurrentUser(): Promise<{
    accessToken: Authorization["accessToken"];
  }> {
    return this.get(['refresh'], undefined, { force: true });
  }
}

export default AuthService;
